import { getAPI } from "../helpers/httpHelper";
import { API_VPP, URL_SUPPORT } from "../helpers/variableHelper";

export default class VppService {
  constructor() {
    console.log("")
  }  

  public static async getAll(token: string, params: any) {
    try{
    let result = await getAPI(
      `${URL_SUPPORT}${API_VPP}/getall`,
      { Authorization: `Bearer ${token}` },
      params
    );
    return result;
  }catch(e){
    return {} as any;
  }
  }
}
